



















import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { QueryAllApps } from '../../api/space/index';
import { getObsToken } from '../../api/common/index';

@Component({
  components: {},
})
export default class Index extends Vue {
  list = [];
  mounted() {
    this.getList();
  }

  async getList() {
    await QueryAllApps().then(res => {
      this.list = res;
    });
  }

  toDetail(code: string) {
    this.$router.push(`/downloadDetail?code=${code}`);
  }
}
